export default __webpack_public_path__ + "static/media/mobile-phone.9d28fbd1.png";